import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Info } from 'lucide-react';
import HowToModal from './HowToModal';
import DrContratoLogo from '../../assets/DrContrato_blue.png';

interface HeaderProps {
  rightLink?: {
    text: string;
    to: string;
    openInNewTab?: boolean;
  };
  enableHowToModal?: boolean;
}

const Header = ({
  rightLink,
  enableHowToModal = false,
}: HeaderProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isHowToOpen, setIsHowToOpen] = useState(false);

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <header className="bg-white shadow w-full sticky top-0 z-50">
      <div className="container mx-4 max-w-6xl sm:px-6 lg:px-8 py-4 flex justify-between items-center text-white">
        <img src={DrContratoLogo} alt="CK Lawyer" className="max-w-[180px]" />
        <div className="flex items-center gap-3">
          {enableHowToModal && (
            <button
              onClick={() => setIsHowToOpen(true)}
              className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 text-white"
            >
              <Info size={16} /> Como usar
            </button>
          )}
          {rightLink &&
            (rightLink.openInNewTab ? (
              <a
                href={rightLink.to}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md bg-gray-700 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 !text-white"
              >
                {rightLink.text}
              </a>
            ) : (
              <button
                onClick={() => handleNavigation(`${rightLink.to}?${searchParams.toString()}`)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-700 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                {rightLink.text}
              </button>
            ))}
        </div>
      </div>
      {enableHowToModal && (
        <HowToModal isOpen={isHowToOpen} onClose={() => setIsHowToOpen(false)} />
      )}
    </header>
  );
};

export default Header;
